import { parseNumberFormatPattern } from '#src/modules/numberFormat/parseNumberFormatPattern'
import type { NumberFormatConfig } from '#src/modules/numberFormat/types'
import { DEFAULT_NUMBER_FORMAT_PATTERN } from '#src/modules/numberFormat/types'
import type { ConfigureRetailSdkOptions } from '#src/services/configureRetailSdkTypes'

let numberFormatConfig: NumberFormatConfig = parseNumberFormatPattern(DEFAULT_NUMBER_FORMAT_PATTERN)
let currencySymbol = ''

export const configureRetailSdk = (options: ConfigureRetailSdkOptions): void => {
  if (options.numberFormat !== undefined) {
    numberFormatConfig = parseNumberFormatPattern(options.numberFormat)
  }

  if (options.currencySymbol !== undefined) {
    currencySymbol = options.currencySymbol
  }
}

export const getNumberFormat = (): Readonly<NumberFormatConfig> => numberFormatConfig

export const getConfiguredCurrencySymbol = (): Readonly<string> => currencySymbol
